import { parseHtmlStringToDom } from '../../utils/domParser';
export function parseElevioArticleUrls(html, baseUrl) {
    try {
        const doc = parseHtmlStringToDom(html);
        const baseUrlWithProtocol = baseUrl.startsWith('http')
            ? baseUrl
            : `https://${baseUrl}`;
        const base = new URL(baseUrlWithProtocol);
        const links = doc.querySelectorAll(`a[href*="${base.hostname}"]`);
        if (links.length === 0)
            return [];
        const IDs = Array.from(links)
            .map((link) => link.getAttribute('href'))
            .filter((value) => !!value);
        return dedupe(IDs);
    }
    catch (_a) {
        return [];
    }
}
function dedupe(array) {
    return [...new Set(array)];
}
